import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { formatPrecio } from '../../utils/formatters';

/**
 * Modal para actualizar precios de productos
 * @param {Object} props
 * @param {boolean} props.show - Controla la visibilidad del modal
 * @param {Function} props.onHide - Handler para cerrar el modal
 * @param {Array} props.productos - Lista de productos a actualizar
 * @param {Object|null} props.preciosUniforme - Precios uniformes si existen
 * @param {Function} props.onActualizar - Handler para actualizar precios
 * @param {boolean} props.updating - Estado de carga
 * @param {string|null} props.error - Mensaje de error
 */
function ModalActualizarPrecios({
  show,
  onHide,
  productos,
  preciosUniforme,
  onActualizar,
  updating,
  error
}) {
  const [preciosForm, setPreciosForm] = useState({
    precio: '',
    preciomenor: ''
  });

  useEffect(() => {
    if (show) {
      if (preciosUniforme) {
        setPreciosForm({
          precio: preciosUniforme.precio,
          preciomenor: preciosUniforme.preciomenor
        });
      } else {
        setPreciosForm({
          precio: '',
          preciomenor: ''
        });
      }
    }
  }, [show, preciosUniforme]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onActualizar(preciosForm);
  };

  const canSubmit = preciosForm.precio || preciosForm.preciomenor;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Actualizar Precios</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          {preciosUniforme ? (
            <Alert variant="info" className="mb-3">
              Los productos filtrados tienen precios uniformes. Puedes actualizarlos todos a la vez.
            </Alert>
          ) : (
            <Alert variant="warning" className="mb-3">
              Los productos filtrados tienen precios diferentes. Los nuevos precios se aplicarán a todos los productos seleccionados.
            </Alert>
          )}
          <p className="mb-3">
            Se actualizarán <strong>{productos.length}</strong> producto{productos.length !== 1 ? 's' : ''}.
          </p>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Precio Mayorista</Form.Label>
              <Form.Control
                type="number"
                value={preciosForm.precio}
                onChange={(e) => setPreciosForm(prev => ({ ...prev, precio: e.target.value }))}
                placeholder="0"
                step="0.01"
                min="0"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Precio Minorista</Form.Label>
              <Form.Control
                type="number"
                value={preciosForm.preciomenor}
                onChange={(e) => setPreciosForm(prev => ({ ...prev, preciomenor: e.target.value }))}
                placeholder="0"
                step="0.01"
                min="0"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={updating}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={updating || !canSubmit}
          >
            {updating ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Actualizando...
              </>
            ) : (
              'Actualizar Precios'
            )}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default ModalActualizarPrecios;

